import { configureStore } from '@reduxjs/toolkit'

import deviceSliceReducer from '@atredux/slices/deviceSlice'
import iframeSliceReducer from '@atredux/slices/iframeSlice'
import ihmLoginTokenInfoSliceReducer from '@atredux/slices/ihmLoginTokenInfoSlice'
import loginTokenInfoSliceReducer from '@atredux/slices/loginTokenInfoSlice'
import localeSliceReducer from '@atredux/slices/localeSlice'
import notificationSliceReducer from '@atredux/slices/notificationSlice'
import storeSliceReducer from '@atredux/slices/storeSlice'
import toolSliceReducer from '@atredux/slices/toolSlice'
import zoneSliceReducer from '@atredux/slices/zoneSlice'
import userRoleSlice from '@atredux/slices/userRoleSlice'
import interruptSlice from '@atredux/slices/interruptSlice'
import atRoleSlice from '@atredux/slices/atRoleSlice'
import atAlertSlice from '@atredux/slices/atAlertSlice'
import connectionsSlice from '@atredux/slices/connectionsSlice'
import announcementsSlice from '@atredux/slices/announcementsSlice'
import inventoryModalSliceReducer from './slices/inventoryViewerModalSlice'
import siteAssistModalSlice from './slices/siteAssistModalSlice'
import { storeContextMiddleware } from './middleware/storeContextMiddleware'
import { zoneSideEffectMiddleware } from './middleware/zoneSideEffectMiddleware'

export const store = configureStore({
    reducer: {
        device: deviceSliceReducer,
        store: storeSliceReducer,
        tool: toolSliceReducer,
        zone: zoneSliceReducer,
        iframe: iframeSliceReducer,
        ihmLoginTokenInfo: ihmLoginTokenInfoSliceReducer,
        loginTokenInfo: loginTokenInfoSliceReducer,
        notification: notificationSliceReducer,
        locale: localeSliceReducer,
        userRole: userRoleSlice,
        interrupt: interruptSlice,
        atRole: atRoleSlice,
        alert: atAlertSlice,
        inventoryViewerModal: inventoryModalSliceReducer,
        siteAssistModal: siteAssistModalSlice,
        connections: connectionsSlice,
        announcements: announcementsSlice,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }).concat(storeContextMiddleware, zoneSideEffectMiddleware),
})

// exporting redux generated types
export type AppStore = typeof store
export type AppGetState = typeof store.getState
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
